import { application } from "./application";

import CmdEnterController from "../../shared/controllers/cmd_enter_controller";
application.register("cmd-enter", CmdEnterController);

import HashcashController from "./hashcash_controller";
application.register("hashcash", HashcashController);
